export default __webpack_public_path__ + "static/media/step4.c61ae47c.png";